// src/routes/AppRoutes.js
import React from 'react'
import { Routes, Route } from 'react-router-dom'

// Public pages
import LandingPage from '../pages/LandingPage'
import LoginPage from '../pages/LoginPage'
import RegisterPage from '../pages/RegisterPage'

// Import the old PrivateLayout file
import PrivateLayout from '../layouts/PrivateLayout'

// Private pages
import DashboardHome from '../components/DashboardHome'
import SendMoneyPage from '../pages/SendMoneyPage'
import RequestMoneyPage from '../pages/RequestMoneyPage'
import PendingRequestsPage from '../pages/PendingRequestsPage'
import HistoryPage from '../pages/HistoryPage'

// NEW: SocialPage
import SocialPage from '../pages/SocialPage'

// NEW: MyPayoutsPage
import MyPayoutsPage from '../pages/MyPayoutsPage'  // <-- Import your new page here

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Private routes use the old PayMe PrivateLayout */}
      <Route element={<PrivateLayout />}>
        <Route path="/dashboard" element={<DashboardHome />} />
        <Route path="/send-money" element={<SendMoneyPage />} />
        <Route path="/request-money" element={<RequestMoneyPage />} />
        <Route path="/pending-requests" element={<PendingRequestsPage />} />
        <Route path="/history" element={<HistoryPage />} />

        {/* NEW: Social Page route */}
        <Route path="/social" element={<SocialPage />} />

        {/* NEW: My Payouts route */}
        <Route path="/my-payouts" element={<MyPayoutsPage />} />
      </Route>

      {/* Optionally handle unmatched routes */}
      {/* <Route path="*" element={<NotFoundPage />} /> */}
    </Routes>
  )
}

export default AppRoutes
